import { combineReducers } from "redux";
import { all } from "redux-saga/effects";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { loadingSlice } from "../app/modules/Common/_redux/loading/loadingSlice";
import { inspectionsSlice } from "../app/modules/Core/_redux/inspections/inspectionsSlice";
import { objectsDataSlice } from "../app/modules/Core/_redux/objectsData/objectsDataSlice";
import { consumptionHistorySlice } from "../app/modules/Fms/_redux/consumptionHistory/consumptionHistorySlice";
import { movementsSlice } from "../app/modules/Fms/_redux/movements/movementsSlice";
import { tpmsRecordsSlice } from "../app/modules/Fms/_redux/tpmsRecords/tpmsRecordsSlice";
import { logEventsSlice } from "../app/modules/Logs/_redux/logEvents/logEventsSlice";
import { forecastsSlice } from "../app/modules/Rundown/_redux/forecasts/forecastsSlice";
import { forecastsHistorySlice } from "../app/modules/Rundown/_redux/forecastsHistory/forecastsHistorySlice";
import { holidaysSlice } from "../app/modules/Rundown/_redux/holidays/holidaysSlice";
import { inventorySlice } from "../app/modules/Rundown/_redux/inventory/inventorySlice";
import { productionsSlice } from "../app/modules/Rundown/_redux/productions/productionsSlice";
import { purchaseOrdersSlice } from "../app/modules/Rundown/_redux/purchaseOrders/purchaseOrdersSlice";
import { userProfileSlice } from "../app/modules/UserProfile/_redux/userProfileSlice";
export const rootReducer = combineReducers({
  auth: auth.reducer,
  objectsData: objectsDataSlice.reducer,
  inspections: inspectionsSlice.reducer,
  holidays: holidaysSlice.reducer,
  productions: productionsSlice.reducer,
  inventory: inventorySlice.reducer,
  purchaseOrders: purchaseOrdersSlice.reducer,
  forecasts: forecastsSlice.reducer,
  forecastsHistory: forecastsHistorySlice.reducer,
  userProfile: userProfileSlice.reducer,
  movements: movementsSlice.reducer,
  logEvents: logEventsSlice.reducer,
  consumptionHistory: consumptionHistorySlice.reducer,
  tpmsRecords: tpmsRecordsSlice.reducer,
  loading: loadingSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
